import React, { useState, useEffect } from "react";

import Interweave from "interweave";
import Head from "next/head";
import { useDispatch } from "react-redux";
// import useSWR from "swr";

import FooterNavComponent from "../../components/FooterComponent/FooterNavComponent/FooterNavComponent";
import GetInTouchComponent from "../../components/FooterComponent/GetInTouchComponent/GetInTouchComponent";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
import TrustedByComponent from "../../components/HomeComponent/TrustedByComponent/TrustedByComponent";
import { NextHead } from "../../components/NextHead/NextHead";
import { _fetchFooterCmsData } from "../../helper/service";
import { clientSideRenderAuth } from "../../store/actions";
import styles from "../../styles/Terms.module.css"
import { AxiosInstance } from "../../utilities";

//
 export default function PrivacyAndPolicy (props)  {
  const [cmsData, setCmsData] = useState(props?.cmsData);

  useEffect(() => {
    fetchCmsData();
  }, []);

  const fetchCmsData = () => {
    let previewId = props.match?.params?.previewId;
    let params = { slug: "privacy-polices" };
    if (previewId) {
      params.previewKey = previewId;
    }

    AxiosInstance(4008, "application/json")
      .post("/pages", params)
      .then((resp) => {
        const response = resp && resp.data;
        if (
          response &&
          (response.status === 200 || response.status === "200")
        ) {
          const responseData = response.data;
          setCmsData(responseData.data[0]);
        }
      })
      .catch((err) => console.log(err));
  };

  const { title, value, description } = cmsData;

  return (
    <React.Fragment>
      <NextHead {...props.seo} />
      <Head>
        <link rel="canonical" href={`${process.env.BASE_URL}/privacy-polices`} />
      </Head>
      <HeaderComponent />
      <section className={styles.agreement_container}>
        <h3 className={styles.sub_heading}>{title}</h3>
        <h1 className={styles.heading}>{value}</h1>
        <div className={styles.agreement_content}>
          <Interweave allowElements={false} content={description} />
        </div>
      </section>
      <GetInTouchComponent />
      <FooterNavComponent />
    </React.Fragment>
  );
}

export async function getServerSideProps(context) {
  const cmsData = {};
  let seo = {};

  

  const params = { slug: "privacy-polices"}
  await AxiosInstance(4008, "application/json")
    .post("/pages", params)
    .then((resp) => {
      const response = resp?.data;
      if (response?.status == 200) {
        const responseData = response.data;
        seo = responseData.seo
        cmsData = responseData.data[0];
      }
    })
    .catch((err) => console.log(err));

  const footerData = await _fetchFooterCmsData();

  return {
    props: {
      cmsData,
      seo,
      footerData,
    },
  };
};
